<template>
  <div class="rounded-md bg-background p-4">
    <div class="mb-2">
      <UiTypography variant="span">Share Your Stream</UiTypography>
    </div>
    <UiTypography class="mb-4 text-sm" variant="p">
      Post to let your followers know you’re going live
    </UiTypography>
    <UiButton variant="secondary" class="w-full" @click="onClick">
      Post to X
    </UiButton>
  </div>
</template>

<script setup lang="ts">
import { openBrowserTo } from '~/lib/bindings';

const props = defineProps({
  text: {
    type: String,
    default: 'I am going live now! Check out my stream.',
  },
});
function onClick() {
  const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(props.text)}`;
  openBrowserTo(url);
}
</script>
